import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-security',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './security.html',
  styleUrl: './security.css',
})
export class SecurityComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Security',
      description: 'How orderYaa ERP protects your business data — encryption, access control, and infrastructure.',
      path: '/security',
    });
  }
}
